
import {LanguageTexts} from '../types'

export const Text: LanguageTexts = {   
  es:{
    'PatientField':'Identificación',
    'PatientMenuTitle':'Opciones paciente',
    'PatientMenuTransfer':'Transferir orden',
    'PatientMenuEditData':'Editar paciente',
    'PatientPrmR':'Permisos insuficientes para buscar pacientes.',
    'PatientNew':'Nuevo paciente',
    'PatientEdit':'Editar paciente',
    'PatientView':'Info. paciente',
  },
  en:{
    'PatientField':'Patient Id',
    'PatientMenuTitle':'Patient options',
    'PatientMenuTransfer':'Transfer Order',
    'PatientMenuEditData':'Edit patient',
    'PatientPrmR':'Insufficient permissions to search for patients',
    'PatientNew':'New patient',
    'PatientEdit':'Edit patient',
    'PatientView':'Info. patient',
  }
};